import { x0, x } from '../../_helpers';
import { throttle } from "lodash";

export default class GsStickyHeaders {

  init() {
    const _this = this;
    window.addEventListener("scroll", throttle(_this.initStickyHeaders, 300));
  }

  initStickyHeaders() {
    requestAnimationFrame(() => {
      setTimeout(() => {
    const headerNavHeight = $(".vbw-secondary-nav").hasClass("vbw-secondary-nav-sticky") ? $(".vbw-secondary-nav").height() : $(".vbw-main-nav").height();
    const isYearlyTab = $(".vbw-gs2-wrapper").hasClass("yearly-tab");
    const matchesHeads = isYearlyTab ? x('.vbw-gs2-calendar .vbw-gs2-status-row') : x('.vbw-gs2-matches .vbw-gs2-date-row');
    const isMonthFilterActive = $(".vbw-gs2-yearly-container").hasClass("active-month-filter");

        matchesHeads?.forEach((matchesHead) => {
          let labelSelClass;
          if (!isYearlyTab) {
            labelSelClass = ".vbw-gs2-date-head";
          } else {
            labelSelClass = isMonthFilterActive ? ".vbw-gs2-month-head" : ".vbw-gs2-status-head";
          }
          const headLabel = x0(labelSelClass, matchesHead);
          const headRect = matchesHead.getBoundingClientRect();

      if (
        (headRect.top <= headerNavHeight) &&
        ((headRect.top + headRect.height) >= headerNavHeight)
      ) {
        headLabel.childNodes[0].style.top = headerNavHeight + 'px';
        headLabel.childNodes[0].style.width = headLabel.offsetWidth + 'px';
        headLabel.classList.add('sticky');
      } else {
        headLabel.classList.remove('sticky');
        headLabel.childNodes[0].style.top = null;
        headLabel.childNodes[0].style.width = null;
      }
    })
      }, 0);
    });
  }
}
